// Import React and Chart.js
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import SaveButton from "../UI/SaveButton";
import { useRef } from "react";
import useExportChartImage from "../useExportChartImage";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const chartColors = {
  male: "#66B3FF", // blu e lehte
  female: "#FF3B3F", // e kuqe e forte
};

const buildChartData = (entry) => {
  const maleModerators = parseInt(entry["Nr. moderatorëve meshkuj"]);
  const femaleModerators = parseInt(entry["Nr. moderatorëve Femra"]);
  const maleGuests = parseInt(entry["Nr. të ftuarve Meshkuj"]);
  const femaleGuests = parseInt(entry["Nr. të ftuarve Femra"]);

  const moderatorTotal = maleModerators + femaleModerators;
  const guestTotal = maleGuests + femaleGuests;

  const moderatorMalePct = ((maleModerators / moderatorTotal) * 100).toFixed(0);
  const moderatorFemalePct = (
    (femaleModerators / moderatorTotal) *
    100
  ).toFixed(0);
  const guestMalePct = ((maleGuests / guestTotal) * 100).toFixed(0);
  const guestFemalePct = ((femaleGuests / guestTotal) * 100).toFixed(0);

  return {
    labels: ["Moderatorë", "Të ftuar"],
    datasets: [
      {
        label: "Meshkuj",
        backgroundColor: chartColors.male,
        data: [moderatorMalePct, guestMalePct],
      },
      {
        label: "Femra",
        backgroundColor: chartColors.female,
        data: [moderatorFemalePct, guestFemalePct],
      },
    ],
  };
};

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "bottom",
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          return `${context.dataset.label}: ${context.raw}%`;
        },
      },
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      max: 100,
      ticks: {
        callback: function (value) {
          return value + "%";
        },
      },
    },
  },
};

const VerticalBarChartGender = ({ entry, title, dataSetting }) => {
  const chartRef = useRef();

  const exportChartImage = useExportChartImage();
  const data = buildChartData(entry);
  const label = entry["Nr. Subjekti"];

  const fileName = dataSetting?.name + "_" + label + "_" + dataSetting?.year;

  const handleExportImage = () => {
    exportChartImage({
      chartRef,
      fileName,
      dataSetting: { ...dataSetting, name: fileName },
    });
  };

  return (
    <div>
      <div ref={chartRef} style={{ width: "400px", marginBottom: "40px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "8px",
          }}
        >
          <div
            style={{
              width: "20px",
              height: "20px",
              backgroundColor: chartColors.female,
            }}
          ></div>
          <strong style={{ color: chartColors.female }}>{label}</strong>
        </div>
        <Bar data={data} options={options} />
      </div>
      <SaveButton onClick={handleExportImage} />
    </div>
  );
};

export default VerticalBarChartGender;
